import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=4ae0fd3a&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae0fd3a",
  null
  
)


    import installComponents from "!/Users/dhulsman/Projects/rentmagic.website.vue.hva/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BAlert, BCol, BRow, BContainer} from 'bootstrap-vue'
    installComponents(component, {BAlert, BCol, BRow, BContainer})
    

export default component.exports